import { Component, EventEmitter, Input, Output } from '@angular/core';
import { takeUntil } from 'rxjs';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { CustomField } from 'src/app/core/models/custom-fields.models';
import { PresetItem } from 'src/app/shared/components/custom-fileds/custom-presets/custom-presets.service';
import { DialogManagerService } from 'src/app/shared/dialogs/dialog-manager.service';

export type CustomFieldMenuItem = {
  label: string;
  fieldTemplate: Partial<CustomField>;
};

const MENU_ITEMS: readonly CustomFieldMenuItem[] = [
  {
    label: 'Text',
    fieldTemplate: {
      type: 'TEXT',
      controlType: 'STRINGINPUT',
    },
  },
  {
    label: 'Number',
    fieldTemplate: {
      type: 'NUMBER',
      controlType: 'NUMBERINPUT',
    },
  },
  {
    label: 'Single Selection',
    fieldTemplate: {
      type: 'SINGLESELECT',
      controlType: 'RADIOBUTTONSLIST',
    },
  },
  {
    label: 'Multi Selection',
    fieldTemplate: {
      type: 'MULTISELECT',
      controlType: 'CHECKBOXESLIST',
    },
  },
  {
    label: 'Date',
    fieldTemplate: {
      type: 'DATE',
      controlType: 'DATEPICKER',
    },
  },
];

@Component({
  selector: 'craft-add-custom-field-menu',
  templateUrl: './add-menu.component.html',
  styleUrls: ['./add-menu.component.scss'],
  standalone: false,
})
export class AddCustomFieldMenuComponent extends Destroyer {
  public list = MENU_ITEMS;
  public presets: PresetItem[];
  @Input() public isForCompany?: boolean;
  @Input() public hideGuruItems = false;
  @Output() public added = new EventEmitter<CustomField>();

  constructor(private dialogManager: DialogManagerService) {
    super();
  }

  public selectPreset(field: Partial<CustomField>): void {
    const menuItem = this.list.find((i) => i.fieldTemplate.type === field.type);
    if (!menuItem) return;

    this.showAddDialog({ ...menuItem, fieldTemplate: { ...menuItem.fieldTemplate, ...field } });
  }

  public showAddDialog(menuItem: CustomFieldMenuItem) {
    return this.dialogManager
      .showCustomFieldEdit({
        orderIndex: Date.now(),
        ...menuItem.fieldTemplate,
        isForCompany: this.isForCompany,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res?.done && res.field) {
          this.added.next(res.field);
        }
      });
  }
}
